module.exports = __webpack_public_path__ + "img/apex.2aac3131.svg";